import { render, staticRenderFns } from "./ProductsTableRowDetails.vue?vue&type=template&id=516438a5&"
import script from "./ProductsTableRowDetails.vue?vue&type=script&lang=js&"
export * from "./ProductsTableRowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports